<template>
  <div class="device d-flex flex-row justify-content-center align-item-center py-3 px-2 border">
    <div class="device-column device-img">
      <img :src="require(`@/assets/img/devices/${device.icon}.png`)" class="icon-device" @click="localize">
      <TimeCount :time="time"></TimeCount>
    </div>
    <div class="device-column device-data">
      <div class="d-flex flex-row align-items-center flex-wrap">
        <strong class="plate m-0"> {{ device.plate }} </strong>
      </div>
      <div class="d-flex flex-row flex-wrap mb-1">
        <DeviceDataIcon v-for="(item, index) in device.data_icons" :key="index" :classes=item.classes :src="item.src" :extra="item.extra"></DeviceDataIcon>
      </div>
      <div class="d-flex flex-row" v-for="(item, index) in device.data_info" :key="index">
        <strong class="title-data">{{ item.title }}</strong>
        <p class="m-0">{{ item.value }}</p>
      </div>
    </div>
    <div class="device-column device-speed px-2">
      <img src="@/assets/img/movement.svg" v-if="device.speed != 0">
      <img src="@/assets/img/stop.svg" v-if="device.speed == 0">
      <strong>{{ device.speed }} Km/h</strong>
    </div>
    <div class="device-column device-btn px-2">
      <img src="@/assets/img/settings-device.svg" class="mb-2" @click="settings">
      <img src="@/assets/img/command-device.svg" @click="command">
    </div>
  </div>
</template>

<script lang="ts">
import DeviceDataIcon from '@/components/DeviceDataIcon.vue';
import TimeCount from '@/components/TimeCount.vue';
import IDeviceView from '@/models/modelView/IDeviceView';
import devicesModule from '@/store/modules/devices.module';
import globalModule from '@/store/modules/global.module';
import mapsModule from '@/store/modules/maps.module';
import DateUtil from '@/utils/date.util';
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
  components: {
    TimeCount,
    DeviceDataIcon
  }
})
export default class ItemDevice extends Vue {

  @Prop(Object) readonly device!: IDeviceView

  time = ''

  get nowTime() {
    return globalModule.nowTime
  }

  @Watch("nowTime", { immediate: true })
  onChangeNowTime(date: Date): void {
    this.time = DateUtil.getStringDiff(date, this.device.time) || ''
  }

  @Emit('command')
  command() {
    return this.device
  }

  @Emit('settings')
  settings() {
    return this.device
  }

  async localize() {
    const device = await devicesModule.getDevicebyId(this.device.id)
    if (device?.position) {
      this.$router.push('/maps')
      mapsModule.mapService.centerPoint(device?.position)
    }

  }

}
</script>

<style lang="sass" scoped>
.device
  border: 1px solid rgba(40, 84, 239, .7)!important
.device-column
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  padding: 0px 5px
.device-speed
  margin-right: 12px
  img
    height: 30px
    margin-bottom: 5px
  strong
    width: min-content
    line-height: 15px
.device-btn
  img
    height: 25px
    &:active
      transform: scale(0.9)
      transition: all 0.1s ease
.device-data
  align-items: flex-start
  padding: 0px 10px
  width: 170px

strong,p
  font-size: 14px
.icon-data
  height: 20px
  display: flex
  padding: 2px 5px
  border-radius: 5px
  margin-right: 3px
  align-items: center
  justify-content: center
  img
    height: 100%
.icon-data:last-child
  margin-right: 0px !important
.key-green
  background: #DBEFDC
  padding: 5.5px
.key-red
  background: #EFDBDB
  padding: 5.5px
.locked-car
  background: #EFDBDB
  padding: 4px 5px
.battery-gps
  background: #DBDDEF
  strong
    color: #2854EF
    font-size: 12px
  img
    margin-right: 4px
.plate
  font-size: 17px
  width: max-content
  margin-right: 5px !important
.title-data
  margin-right: 5px
.icon-device
  width: 50px
  height: auto !important
</style>
  